import { render, staticRenderFns } from "./BtnFile.vue?vue&type=template&id=6ec55397&"
import script from "./BtnFile.vue?vue&type=script&lang=js&"
export * from "./BtnFile.vue?vue&type=script&lang=js&"
import style0 from "./BtnFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports